if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}

// new js 10/3/2023
// Get the modal
 $(document).on("click",".show_modal",function() {
   var getmodalclass = $(this).attr("data-id");
   $("."+getmodalclass).show();
   $("body").addClass("modal-open");
 });
 $(document).on("click",".close",function() {
   var getmodalclass = $(this).attr("data-id");
   $("."+getmodalclass).hide();
   $("body").removeClass("modal-open");
 });
$(document).on("click",".confirm_area_btn",function() {
   var getmodalclass = $(this).attr("data-id");
   $("."+getmodalclass).hide();
   $("body").removeClass("modal-open");
 });
$("body").click(function(){
  $(".how_to_measure").hide();
  $("body").removeClass("modal-open");
  });

$(".how_to_measure .modal-body").click(function(e){
       e.stopPropagation();
});
$(".how_to_measure .innerh2").click(function(e){
       e.stopPropagation();
});



